export const youtubeVideo = () => {
  const $ = jQuery
  const __allytifr = document.querySelectorAll('.video_container')

  function getMinSec(time) {
    const min = parseInt(time / 60, 10)
    const sec = parseInt(time - min * 60)
    const returnValue = min > 0 ? min + "'" : ''
    return returnValue + sec + "''"
  }

  if (__allytifr?.length > 0) {
    // Load the IFrame Player API code asynchronously.
    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/player_api'
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

    for (let i = 0; i < __allytifr.length; i++) {
      const id = Math.round(Math.random() * 8999 + 1000)
      $(__allytifr[i]).find('.video_wrapper .video').attr('id', id)
    }

    window.ytplayer = {
      timers: {},
      onPlayerStateChange: function (state) {
        const videoContainer = state.target.g.closest('.video_container')
        const progressbar = videoContainer.querySelector('.cover_controls .controls .progressbar input')
        const videoId = videoContainer.querySelector('.video_wrapper').dataset.videoid

        if (state.data === 1) {
          window.ytplayer[videoId] = setInterval(() => {
            let currentTime = state?.target.getCurrentTime()
            currentTime = Math.round((currentTime / state.target.getDuration()) * 100)
            progressbar.setAttribute('value', currentTime)
            const durationCounter = state?.target.getDuration() - currentTime
            videoContainer.querySelector('.cover_controls .controls .time').innerText = getMinSec(durationCounter)
          }, 300)
        } else {
          clearInterval(window.ytplayer[videoId])
        }
      },
      onPlayerReady: function (event) {
        const videoContainer = event.target.g.closest('.video_container')
        const playBtn = videoContainer.querySelector('.cover_controls .controls .btn_play')
        const progressbar = videoContainer.querySelector('.cover_controls .controls .progressbar input')
        const imageCover = videoContainer.querySelector('.cover_controls .cover')
        const displayedTime = videoContainer.querySelector('.cover_controls .controls .time')
        const muteBtn = videoContainer.querySelector('.cover_controls .controls .btn_audio a')
        const audioInput = videoContainer.querySelector('.cover_controls .controls .btn_audio input')
        const playSvg = playBtn.querySelector('.play')
        const pauseSvg = playBtn.querySelector('.pause')

        const state = {
          duration: 0,
          current_time: 0,
          playing: false,
          muted: false,
          volume: 5,
          progress: 0,
          visible: false
        }

        // add duration
        const duration = getMinSec(event.target.getDuration())
        displayedTime.innerText = duration

        // play and pause event
        playBtn.addEventListener('click', function (e) {
          e.preventDefault()
          imageCover.classList.add('hide')
          if (!state.playing) {
            event.target.playVideo()
            playSvg.classList.add('hide')
            pauseSvg.classList.remove('hide')
            state.playing = true
          } else {
            event.target.pauseVideo()
            pauseSvg.classList.add('hide')
            playSvg.classList.remove('hide')
            state.playing = false
          }
        })

        progressbar.addEventListener('change', function (e) {
          imageCover.classList.add('hide')
          const value = parseInt(e.currentTarget.value, 10)
          const newSecond = Math.round((event.target.getDuration() * value) / 100)
          event.target.seekTo(newSecond)
        })

        muteBtn.addEventListener('click', function (e) {
          e.preventDefault()
          if (!state.muted) {
            event.target.mute()
            event.target.setVolume(0)
            audioInput.setAttribute('value', 10)
            audioInput.value = 10
            state.muted = true
          } else {
            event.target.unMute()
            event.target.setVolume(state.volume * 10)
            audioInput.setAttribute('value', 10 - state.volume)
            audioInput.value = 10 - state.volume
            state.muted = false
          }
        })

        audioInput.addEventListener('change', function (e) {
          const value = parseInt(e.currentTarget.value, 10)
          audioInput.setAttribute('value', value)
          state.volume = 10 - value
          event.target.setVolume((10 - value) * 10)
        })
      },
      onYouTubeIframeAPIReady: function () {
        for (let i = 0; i < __allytifr.length; i++) {
          const id = __allytifr[i].querySelector('.video_wrapper .video').id
          const videoId = __allytifr[i].querySelector('.video_wrapper').dataset.videoid
          window.ytplayer[videoId] = {}
          // const playBtn = __allytifr[i].querySelector('.cover_controls .btn_play')

          // eslint-disable-next-line
          new YT.Player(id, {
            videoId: videoId,
            host: 'https://www.youtube-nocookie.com',
            playerVars: {
              controls: 0,
              showinfo: 0,
              rel: 0,
              iv_load_policy: 3,
              autoplay: 0,
              loop: 0,
              mute: 0,
              volume: 5,
              disablekb: 1,
              enablejsapi: 1,
              widgetid: 1,
              origin: window.location.origin
            },
            events: {
              onReady: window.ytplayer.onPlayerReady,
              onStateChange: window.ytplayer.onPlayerStateChange
            }
          })
        }
      }
    }
  }
}
